import { Component } from '@angular/core';
import { HelperService } from 'src/app/core/services/helper.service';
import { opacityInOut } from 'src/app/shared/animations/opacity-in-out.animation';
import { scaleInOut } from 'src/app/shared/animations/scale-in-out.animation';

@Component({
  selector: 'video-popup',
  templateUrl: 'video-popup.component.html',
  styleUrls: ['video-popup.component.scss'],
  animations: [ opacityInOut, scaleInOut ]
})
export class VideoPopupComponent {

  showVideo = false;

  constructor(private helperService: HelperService) {
  }

  toggleShowVideo() {
    this.showVideo = !this.showVideo;
    this.helperService.blockScroll$.next(this.showVideo);
  }

}
